<template>
  <v-card flat>
    <v-card-text>
      <v-row
        justify="space-between"
      >
        <v-col cols="auto">
          <v-card width="256">
            <v-navigation-drawer permanent>
              <v-list
                dense
                rounded
              >
                <v-list-item
                  v-for="marketplace in marketplaces"
                  :key="marketplace.id"
                  link
                  :to="'/images/' + marketplace.id"
                >
                  <v-list-item-content>
                    <v-list-item-title>{{ marketplace.name }}</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </v-list>
              <template v-slot:append>
                <div class="pa-2">
                  <v-dialog v-model="marketplaceDialog" max-width="500px">
                    <template v-slot:activator="{ on }">
                      <v-btn 
                        elevation="0 mb-2"
                        color="primary"
                        small
                        dark
                        block
                        v-on="on"
                      >
                        Add marketplace
                      </v-btn>
                    </template>
                    <v-card>
                      <ValidationObserver v-slot="{ handleSubmit }">
                        <v-card-title>
                          <span class="headline">Add marketplace</span>
                        </v-card-title>
                        <v-card-text>
                          <v-container>
                            <v-row>
                              <v-col cols="12">
                                <ValidationProvider name="name" rules="required" v-slot="{ errors }">
                                  <v-text-field
                                    v-model="newMarketpalce.name"
                                    label="Name"
                                    placeholder="Enter marketpalce name"
                                    outlined
                                    dense
                                    :error-messages="errors[0]"
                                  />
                                </ValidationProvider>
                              </v-col>
                            </v-row>
                          </v-container>
                        </v-card-text>
                        <v-card-actions>
                          <v-spacer></v-spacer>
                          <v-btn color="blue darken-1" text @click="closeMarketplace">Cancel</v-btn>
                          <v-btn color="blue darken-1" text @click="handleSubmit(saveMarketplace)">Save</v-btn>
                        </v-card-actions>
                      </ValidationObserver>
                    </v-card>
                  </v-dialog>
                  <v-dialog v-model="titleDialog" max-width="500px">
                    <template v-slot:activator="{ on }">
                      <v-btn 
                        elevation="0"
                        color="success"
                        small
                        dark
                        block
                        v-on="on"
                      >
                        Add title
                      </v-btn>
                    </template>
                    <v-card>
                      <ValidationObserver v-slot="{ handleSubmit }">
                        <v-card-title>
                          <span class="headline">Add title</span>
                        </v-card-title>
                        <v-card-text>
                          <v-container>
                            <v-row>
                              <v-col cols="12">
                                <ValidationProvider name="name" rules="required" v-slot="{ errors }">
                                  <v-text-field
                                    v-model="newTitle.name"
                                    label="Name"
                                    placeholder="Enter title name"
                                    outlined
                                    dense
                                    :error-messages="errors[0]"
                                  />
                                </ValidationProvider>
                              </v-col>
                            </v-row>
                          </v-container>
                        </v-card-text>
                        <v-card-actions>
                          <v-spacer></v-spacer>
                          <v-btn color="blue darken-1" text @click="closeTitle">Cancel</v-btn>
                          <v-btn color="blue darken-1" text @click="handleSubmit(saveTitle)">Save</v-btn>
                        </v-card-actions>
                      </ValidationObserver>
                    </v-card>
                  </v-dialog>
                </div>
              </template>
            </v-navigation-drawer>
          </v-card>
        </v-col>
        <v-divider vertical></v-divider>
        <v-col>
          <div
            v-if="!$route.params.id"
            class="title font-weight-light grey--text pa-4 text-center"
          >
            Select marketplace
          </div>
          <router-view 
            :titles="titles"
          ></router-view>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  data: () => ({
    loadingMarketplaceData: false,
    marketplaceDialog: false,
    newMarketpalce: {
      name: null
    },
    defaultMarketpalce: {
      name: null
    },
    marketplaces: [],
    titleDialog: false,
    newTitle: {
      name: null
    },
    defaultTitle: {
      name: null
    },
    titles: [],
  }),
  created() {
    this.$axios.get('/api/marketplaces')
    .then(payload => this.marketplaces.push(...payload.data))
    .catch(err => console.warn(err));

    this.$axios.get('/api/titles')
    .then(payload => this.titles.push(...payload.data))
    .catch(err => console.warn(err));
  },
  methods: {
    async saveMarketplace() {
      try {
        const { data } = await this.$axios.post('/api/marketplace', this.newMarketpalce);
        if (data.message) {
          this.$toasted.info(data.message);
        } else {
          this.marketplaces.push(data);
          this.$toasted.success('Marketpalce seccessfully added');
          this.closeMarketplace();
        }
      } catch(err) {
        this.$toasted.error('Oops. Something went wrong');
      }
    },
    closeMarketplace() {
      this.marketplaceDialog = false;
      this.newMarketpalce = Object.assign({}, this.defaultMarketpalce);
    },
    async saveTitle() {
      try {
        const { data } = await this.$axios.post('/api/title', this.newTitle);
        if (data.message) {
          this.$toasted.info(data.message);
        } else {
          this.titles.push(data);
          this.$toasted.success('Title seccessfully added');
          this.closeTitle();
        }
      } catch(err) {
        this.$toasted.error('Oops. Something went wrong');
      }
    },
    closeTitle() {
      this.titleDialog = false;
      this.newTitle = Object.assign({}, this.defaultTitle);
    },
  }
}
</script>